import { Admin } from './../../models/program/admin';
import { ExistingUser } from './../../models/program/existing-user';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

import { ApiService } from '../../root-services/api.service';

@Injectable()
export class SearchService {

  constructor(private api: ApiService) { }

  public queryAdmins(name: string): Observable<Admin[]> {
    return this.api.get(`/admins?search=${name}`)
                   .map(res => res.json() as Admin[])
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public queryExistingUsers(name: string, includeCompletion?: boolean): Observable<ExistingUser[]> {
    const includeCompletionParam = includeCompletion ? "include_completion=1&" : "";
    return this.api.get(`/search?restrict=users&${includeCompletionParam}query=${name}`)
                   .map(res => res.json().users as ExistingUser[])
                   .publishReplay(1).refCount()
                   .catch(this.handleError);
  }

  public queryAll(query: string): Observable<Object[]> {
    return this.api.get(`/search?query=${query}`)
      .map(res => res.json() as Object[])
      .publishReplay(1).refCount()
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occured:', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/services/search.service.ts